import React from "react";
import '../loader/loadingspinner.css';

class LoadingSpinner extends React.Component {

    render() {
        return (
            <div className="loader" ></div>
        )
    }
}

export default LoadingSpinner;